<template>
  <span class="snippet" v-html="snippet.value"> </span>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: 'Snippet',
  props: {
    name: {
      type: String
    }
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      snippet: {
        key: '',
        value: '',
        format: '',
      }
    }
  },
  computed: {
    ...mapGetters(["snippets"]),
  },
  watch: {
    snippets(items, prevItems) {
      if (items instanceof Array && prevItems instanceof Array) {
        if (items.length > prevItems.length) {
          this.load();
        }
      }
    },
    name(val, prevVal) {
      if (val !== prevVal) {
        this.load();
      }
    }
  },
  methods: {
    load() {
      if (this.name.length > 2 && this.snippets.length > 1) {
        const snippet = this.snippets.find(sn => sn.key === this.name);
        if (snippet) {
          if (snippet.value) {
            this.snippet = snippet
          }
        }
      }
    }
  }
}
</script>
